import React, { useEffect, useState } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import AssetsLinks from "../../../components/cases/assets";

const AdvisorAssets = () => {
  const [data, handleRefresh, location] = useOutletContext();
  const path = location.pathname.split("/");
  return path[path?.length - 1] === "balance-of-assets" ? (
    <Outlet />
  ) : (
    <AssetsLinks />
  );
};

export default AdvisorAssets;
